import { combineReducers, createReducer } from "@reduxjs/toolkit";
import {
  projectsDeleteDialog, projectsDeleteError, projectsDeleteStart, projectsDeleteSuccess
} from "../Actions";

const showDialog = createReducer(false, {
  [projectsDeleteDialog.type]: (_, { payload }) => payload,
  [projectsDeleteError.type]: () => false,
  [projectsDeleteSuccess.type]: () => false
});

export const Delete = combineReducers({
  showDialog
});
